import type { MailContentProps, MailMetadata } from "../../lib/types";
import { MailSignature } from "../mail/mail-signature";

function DematerialisationDocumentationTechnique({
  variablesData,
}: MailContentProps) {
  return (
    <div className="space-y-2">
      <p>Que fait-on ?</p>
      <MailSignature
        emetteurLogo={
          DematerialisationDocumentationTechnique.metadata.emetteurLogo
        }
        emetteur={DematerialisationDocumentationTechnique.metadata.emetteur}
        emetteurPoste={
          DematerialisationDocumentationTechnique.metadata.emetteurPoste
        }
        emetteurEntreprise={
          DematerialisationDocumentationTechnique.metadata.emetteurEntreprise
        }
      />

      <div className="mt-6">
        <div className="italic">Message transféré :</div>
        <div className="mt-2 space-y-4 border-l-4 border-gray-300 pl-4 text-gray-600">
          <p>Bonjour,</p>
          <p>
            Afin de faciliter la recherche d'informations et l'utilisation des
            ouvrages techniques, je pense qu'il serait intéressant de concevoir
            une gestion informatisée de l'ensemble de la documentation
            technique.
          </p>
          <p>
            J'aimerais personnellement résoudre ce problème par la conception
            d'un logiciel adapté à nos besoins propres et permettant
            d'introduire une plus grande souplesse quant à l'utilisation des
            ouvrages.
          </p>
          <p>
            L'abandon de mon précédent projet (informatisation de la gestion du
            personnel) allégeant ma charge de travail, je pense avoir le temps
            nécessaire à la réalisation de ce nouveau projet.
          </p>
          <p>
            De plus, un système similaire est en expérimentation à notre siège
            parisien et je suis prêt à me rendre sur place, avec votre
            autorisation, pour capitaliser les éléments de cette expérimentation
            au bénéfice de notre Établissement
          </p>
          <div>
            <p className="font-bold">
              {variablesData.employe_administratif_prenom}{" "}
              {variablesData.employe_administratif_nom}
            </p>
            <p>{variablesData.employe_administratif_fonction}</p>
            <p>{variablesData.employe_administratif_societe}</p>
          </div>
        </div>
      </div>
    </div>
  );
}

DematerialisationDocumentationTechnique.metadata = {
  titre: "Dématérialisation de la documentation technique",
  cleMail: "dematerialisation_documentation_technique",
  messageTransfert: true,
  emetteur: "François AS",
  emetteurPoste: "Responsable du service administratif",
  emetteurEntreprise: "SYTEL Grand Est",
  emetteurLogo: "/logos/sytel_grand_est.png",
  dateRelative: -10,
  piecesJointes: [],
} as MailMetadata;

export default DematerialisationDocumentationTechnique;
